import { registerUser } from "../features/signup/signup.slice";

export const signupActions = {
  register: {
    action: registerUser,
    type: 'signup/registerUser'
  }
};

export const prepareRegistrationPayload = (formData: any, accountType: string, currentLanguage: string , tduid: string | null) => {
  // const nameParts = formData.fullName;
  // const firstName = nameParts[0] || '';

  return {
    id: 0,
    firstName: formData.firstName ,
    lastName: formData.lastName,
    email: formData.email,
    password: formData.password,
    phoneNo: formData.phoneNo || '',
    ssn: formData.noIdNumber ? '' : formData.socialSecurityNumber,
    dateBirth: formData.noIdNumber ? formData.dateOfBirth : '',
    dateOfBirth: formData.noIdNumber ? formData.dateOfBirth : '',
    profession: "", // Default profession
    address: formData.address, // Default address
    city: "", // Default city
    country: formData.country, // Default country
    zipCode: formData.zipCode, // Default postal code
    organisation: "",
    accountType: accountType === 'freelancer' ? 1 : 2,
    invitedBy: 0,
    invitedByAmbassador: false,
    ReferredByCode: '',
    ReferredByUserId: '',
    socialPlatformId: '',
    accountNumber: '',
    bank: '',
    clearingNumber: '',
    ibanNumber: '',
    bicNumber: '',
    otherBank: '',
    tduid: tduid ?? null,
    language: currentLanguage,
  };
};

// Type definitions for better TypeScript support
export interface RegistrationFormData {
  fullName: string;
  email: string;
  password: string;
  socialSecurityNumber: string;
  dateOfBirth: string;
  noIdNumber: boolean;
  agreeToTerms: boolean;
}

export interface RegistrationPayload {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phoneNo: string;
  ssn: string;
  dateBirth: string;
  dateOfBirth: string;
  profession: string;
  address: string;
  city: string;
  country: string;
  zipCode: string;
  organisation: string;
  accountType: number;
  invitedBy: number;
  invitedByAmbassador: boolean;
  socialPlatformId: string;
  ReferredByCode: string;
  ReferredByUserId: number | null;
  accountNumber: string;
  bank: string;
  clearingNumber: string;
  ibanNumber: string;
  bicNumber: string;
  otherBank: string;
  language: string;
}
